export const brregTexts = [
    {
        label: 'Kunst og kultur',
        id: '100',
        texts: [
            {
                label: 'Skuespiller.',
                synonyms: [],
                id: '1040',
                importanceRank: 1000,
                verboseModifier: 'scenekunst',
                industryCode: '90.012',
            },
            {
                label: 'Produksjon av digital kunst.',
                synonyms: [],
                id: '1041',
                importanceRank: 1000,
                verboseModifier: 'digital kunst',
                industryCode: '90.031',
            },
            {
                label: 'Blomsterdekoratør.',
                synonyms: ['florist'],
                id: '1042',
                importanceRank: 1000,
                verboseModifier: 'blomsterdekorasjon',
                industryCode: '90.031',
            },
            {
                label: 'Foredragsholder.',
                synonyms: ['Foredrag, taler, konferansier'],
                id: '1050',
                importanceRank: 2,
                verboseModifier: 'foredrag',
                industryCode: '90.019',
            },
            {
                label: 'Scenetjenester som instruktør.',
                synonyms: ['Instruktør', 'Teater'],
                id: '1060',
                importanceRank: 1000,
                verboseModifier: 'scenetjenester',
                industryCode: '90.020',
            },
            {
                label: 'Scenetjenester som produsent.',
                synonyms: ['Produsent', 'Teater'],
                id: '1062',
                importanceRank: 2,
                verboseModifier: 'scenetjenester',
                industryCode: '90.020',
            },
            {
                label: 'Lydtekniker.',
                synonyms: ['Lydmann'],
                id: '1064',
                importanceRank: 2,
                verboseModifier: 'scenetjenester',
                industryCode: '90.020',
            },
            {
                label: 'Lystekniker.',
                synonyms: ['Lysmann'],
                id: '1066',
                importanceRank: 2,
                verboseModifier: 'scenetjenester',
                industryCode: '90.020',
            },
            {
                label: 'Scenetjenester som regissør.',
                synonyms: ['Regissør, regi'],
                id: '1068',
                importanceRank: 1000,
                verboseModifier: 'scenetjenester',
                industryCode: '90.020',
            },
            {
                label: 'Manager for skuespillere, musikere og andre kunstnere.',
                synonyms: ['management'],
                id: '1070',
                importanceRank: 2,
                verboseModifier: 'talent management',
                industryCode: '74.903',
            },
            {
                label: 'Produksjon av musikk.',
                synonyms: ['Musikk', 'Produsent', 'Komponist', 'Låtskriver'],
                id: '1110',
                importanceRank: 2,
                verboseModifier: 'produksjon av musikk',
                industryCode: '59.200',
            },
            {
                label: 'Utgivelse av musikk og lydopptak.',
                synonyms: [],
                id: '1120',
                importanceRank: 1000,
                verboseModifier: 'utgivelse av musikk og lyd',
                industryCode: '59.200',
            },
            {
                label: 'Produksjon av film, video og fjernsynsprogram.',
                synonyms: ['TV-produsent', 'Film', 'TV'],
                id: '1130',
                importanceRank: 2,
                verboseModifier: 'produksjon av video',
                industryCode: '59.110',
            },
            {
                label: 'Kunstfotograf.',
                synonyms: [],
                id: '1135',
                importanceRank: 1,
                verboseModifier: 'kunstfotografi',
                industryCode: '74.200',
            },
        ],
    },
    {
        label: 'Dyr',
        id: '110',
        texts: [
            {
                label: 'Oppdrett av hunder, katter eller andre kjæledyr.',
                synonyms: [],
                id: '1250',
                importanceRank: 1000,
                verboseModifier: 'oppdrett av kjæledyr',
                industryCode: '01.490',
            },
        ],
    },
    {
        label: 'Dyr',
        id: '120',
        texts: [
            {
                label: 'Klipping av sauer.',
                synonyms: [],
                id: '1272',
                importanceRank: 1000,
                verboseModifier: 'husdyrhold',
                industryCode: '01.620',
            },
            {
                label: 'Hovslager.',
                synonyms: [],
                id: '1274',
                importanceRank: 1000,
                verboseModifier: 'husdyrhold',
                industryCode: '01.620',
            },
            {
                label: 'Veterinærtjenester.',
                synonyms: ['Vetrinær', 'Dyrlege'],
                id: '1280',
                importanceRank: 2,
                verboseModifier: 'veterinærmedisin',
                industryCode: '75.000',
            },
            {
                label: 'Hundedressur.',
                synonyms: ['hundetrening'],
                id: '1290',
                importanceRank: 2,
                verboseModifier: 'hundedressur',
                industryCode: '96.090',
            },
            {
                label: 'Kennel (hunde- eller kattepass).',
                synonyms: ['Dyrepass'],
                id: '1300',
                importanceRank: 2,
                verboseModifier: 'dyrepass',
                industryCode: '96.090',
            },
        ],
    },
    {
        label: 'Skogbruk',
        id: '140',
        texts: [
            {
                label: 'Avvirkning, tømmerhogst og vedhogst på oppdrag hos skogeiere.',
                synonyms: [],
                id: '1380',
                importanceRank: 1000,
                verboseModifier: 'skogbruk',
                industryCode: '02.400',
            },
            {
                label: 'Tjenester tilknyttet skogbruk, skogsentreprenør.',
                synonyms: [],
                id: '1390',
                importanceRank: 1000,
                verboseModifier: 'skogbruk',
                industryCode: '02.400',
            },
            {
                label: 'Skogskjøtsel, planting og rydding på oppdrag.',
                synonyms: [],
                id: '1400',
                importanceRank: 1000,
                verboseModifier: 'skogskjøtsel',
                industryCode: '02.100',
            },
        ],
    },
    {
        label: 'Fiske',
        id: '150',
        texts: [
            {
                label: 'Hav- og kystfiske.',
                synonyms: [],
                id: '1410',
                importanceRank: 1000,
                verboseModifier: 'havfiske',
                industryCode: '03.111',
            },
            {
                label: 'Ferskvannsfiske.',
                synonyms: [],
                id: '1420',
                importanceRank: 1000,
                verboseModifier: 'ferskvannsfiske',
                industryCode: '03.120',
            },
        ],
    },
    {
        label: 'Bygg og anlegg',
        id: '160',
        texts: [
            {
                label: 'Tømrer, oppføring og vedlikehold av bygninger.',
                synonyms: [],
                id: '1430',
                importanceRank: 2,
                verboseModifier: 'oppføring av bygninger',
                industryCode: '41.200',
            },
            {
                label: 'Snekkerarbeid, montering av dører, vinduer, kjøkken med mer.',
                synonyms: ['Håndverker'],
                id: '1440',
                importanceRank: 1,
                verboseModifier: 'snekkerarbeid',
                industryCode: '43.320',
            },
            {
                label: 'Rørleggertjenester.',
                synonyms: ['Rørlegger'],
                id: '1450',
                importanceRank: 1,
                verboseModifier: 'rørleggerarbeid',
                industryCode: '43.221',
            },
            {
                label: 'Elektrikertjenester.',
                synonyms: ['Elektriker'],
                id: '1460',
                importanceRank: 1,
                verboseModifier: 'elektrikerarbeid',
                industryCode: '43.210',
            },
            {
                label: 'Malertjenester.',
                synonyms: ['Maler', 'Male'],
                id: '1470',
                importanceRank: 2,
                verboseModifier: 'malerarbeid',
                industryCode: '43.341',
            },
            {
                label: 'Gulvlegging, flislegging og tapetsering.',
                synonyms: ['Håndverker'],
                id: '1480',
                importanceRank: 2,
                verboseModifier: 'gulvlegging',
                industryCode: '43.330',
            },
            {
                label: 'Grunnarbeid (graving, drenering, sprengning, planering).',
                synonyms: [],
                id: '1490',
                importanceRank: 2,
                verboseModifier: 'grunnarbeid',
                industryCode: '43.120',
            },
            {
                label: 'Murertjenester.',
                synonyms: ['murer'],
                id: '1500',
                importanceRank: 2,
                verboseModifier: 'murerarbeid',
                industryCode: '43.990',
            },
            {
                label: 'Blikkenslagertjenester (på tak).',
                synonyms: ['blikkenslager'],
                id: '1510',
                importanceRank: 2,
                verboseModifier: 'blikkenslagerarbeid',
                industryCode: '43.911',
            },
            {
                label: 'Blikkenslagertjenester (ventilasjon, kanaler).',
                synonyms: ['blikkenslager'],
                id: '1520',
                importanceRank: 2,
                verboseModifier: 'ventilasjonsarbeid',
                industryCode: '43.223',
            },
            {
                label: 'Installasjon av kuldeanlegg og varmepumper.',
                synonyms: [],
                id: '1530',
                importanceRank: 2,
                verboseModifier: 'installasjon av kuldeanlegg og varmepumper',
                industryCode: '43.222',
            },
            {
                label: 'Ingeniør- og prosjektledertjenester innen byggeprosjekter.',
                synonyms: [],
                id: '1540',
                importanceRank: 2,
                verboseModifier: 'byggteknisk konsulentvirksomhet',
                industryCode: '71.121',
            },
            {
                label: 'Totalentreprenør for utvikling av byggeprosjekter for salg eller utleie.',
                synonyms: ['Entreprenør', 'Bygg', 'Eiendomsutvikling'],
                id: '1545',
                importanceRank: 1,
                verboseModifier: 'byggeprosjekter',
                industryCode: '41.109',
            },
        ],
    },
    {
        label: 'Undervisning',
        id: '170',
        texts: [
            {
                label: 'Undervisning innen sport og idrett.',
                synonyms: [],
                id: '1575',
                importanceRank: 2,
                verboseModifier: 'undervisning innen sport og idrett',
                industryCode: '85.510',
            },
            {
                label: 'Undervisning i musikk.',
                synonyms: ['Musikklærer', 'Musikkpedagog'],
                id: '1580',
                importanceRank: 1000,
                verboseModifier: 'undervisning i kunstfag',
                industryCode: '85.522',
            },
            {
                label: 'Undervisning i dans.',
                synonyms: ['Dansepedagog', 'Danselærer'],
                id: '1590',
                importanceRank: 1000,
                verboseModifier: 'undervisning i kunstfag',
                industryCode: '85.522',
            },
            {
                label: 'Undervisning i ridning.',
                synonyms: ['Ridelærer'],
                id: '1591',
                importanceRank: 1000,
                verboseModifier: 'rideundervisning',
                industryCode: '85.510',
            },
            {
                label: 'Trafikkskole/kjøreskole.',
                synonyms: ['Kjørelærer'],
                id: '1600',
                importanceRank: 1000,
                verboseModifier: 'trafikkskoleundervisning',
                industryCode: '85.530',
            },
        ],
    },
    {
        label: 'IT',
        id: '180',
        texts: [
            {
                label: 'Konsulenttjenester innen IT.',
                synonyms: ['IT-konsulent'],
                id: '1620',
                importanceRank: 1,
                verboseModifier: 'IT',
                industryCode: '62.020',
            },
            {
                label: 'Programvareutvikling.',
                synonyms: ['Utvikler', 'teknologi', 'software', 'tech'],
                id: '1629',
                importanceRank: 1,
                verboseModifier: 'programvare',
                industryCode: '62.010',
            },
            {
                label: 'Programmering.',
                synonyms: ['utvikler'],
                id: '1630',
                importanceRank: 1,
                verboseModifier: 'programmering',
                industryCode: '62.010',
            },
            {
                label: 'Drift av web-portaler.',
                synonyms: [],
                id: '1650',
                importanceRank: 2,
                verboseModifier: 'drift av web-portaler',
                industryCode: '63.120',
            },
        ],
    },
    {
        label: 'Design',
        id: '190',
        texts: [
            {
                label: 'Industridesign, produktdesign.',
                synonyms: [],
                id: '1670',
                importanceRank: 1,
                verboseModifier: 'industridesign',
                industryCode: '74.101',
            },
            {
                label: 'Grafisk design.',
                synonyms: [],
                id: '1680',
                importanceRank: 1,
                verboseModifier: 'grafisk design',
                industryCode: '74.102',
            },
            {
                label: 'WEB-design.',
                synonyms: ['UX-designer'],
                id: '1690',
                importanceRank: 2,
                verboseModifier: 'Webdesign',
                industryCode: '62.010',
            },
            {
                label: 'Design av klær.',
                synonyms: ['Klesdesigner', 'mote', 'fashion'],
                id: '1691',
                importanceRank: 2,
                verboseModifier: 'klesdesign',
                industryCode: '74.101',
            },
            {
                label: 'Design av 3D modeller og 3D printing.',
                synonyms: ['Modellering', 'prototyping'],
                id: '1692',
                importanceRank: 2,
                verboseModifier: 'teknisk design',
                industryCode: '74.101',
            },
            {
                label: 'Interiørdesign.',
                synonyms: [],
                id: '1700',
                importanceRank: 1,
                verboseModifier: 'interiørdesign',
                industryCode: '74.103',
            },
        ],
    },
    {
        label: 'Skjønnhet',
        id: '200',
        texts: [
            {
                label: 'Frisering og skjønnhetspleie.',
                synonyms: ['Frisør', 'Klinikk'],
                id: '1710',
                importanceRank: 1,
                verboseModifier: 'skjønnhetspleie',
                industryCode: '96.020',
            },
            {
                label: 'Hudpleie.',
                synonyms: ['Klinikk'],
                id: '1720',
                importanceRank: 2,
                verboseModifier: 'skjønnhetspleie',
                industryCode: '96.020',
            },
            {
                label: 'Negledesign.',
                synonyms: ['negltekniker'],
                id: '1730',
                importanceRank: 1000,
                verboseModifier: 'skjønnhetspleie',
                industryCode: '96.020',
            },
            {
                label: 'Manikyr.',
                synonyms: [],
                id: '1740',
                importanceRank: 1000,
                verboseModifier: 'skjønnhetspleie',
                industryCode: '96.020',
            },
            {
                label: 'Pedikyr.',
                synonyms: [],
                id: '1750',
                importanceRank: 1000,
                verboseModifier: 'skjønnhetspleie',
                industryCode: '96.020',
            },
            {
                label: 'Tatovering.',
                synonyms: [],
                id: '1760',
                importanceRank: 2,
                verboseModifier: 'tatovering',
                industryCode: '96.090',
            },
            {
                label: 'Piercing.',
                synonyms: [],
                id: '1770',
                importanceRank: 1000,
                verboseModifier: 'piercing',
                industryCode: '96.090',
            },
        ],
    },
    {
        label: 'Velvære',
        id: '210',
        texts: [
            {
                label: 'Drift av solarium.',
                synonyms: [],
                id: '1780',
                importanceRank: 1000,
                verboseModifier: 'kroppspleie og fysisk velvære',
                industryCode: '96.040',
            },
            {
                label: 'Drift av SPA.',
                synonyms: [],
                id: '1790',
                importanceRank: 2,
                verboseModifier: 'kroppspleie og fysisk velvære',
                industryCode: '96.040',
            },
            {
                label: 'Velværemassasje.',
                synonyms: ['Massasje'],
                id: '1800',
                importanceRank: 1000,
                verboseModifier: 'kroppspleie og fysisk velvære',
                industryCode: '96.040',
            },
        ],
    },
    {
        label: 'Helse og omsorg',
        id: '220',
        texts: [
            {
                label: 'Allmennlege.',
                synonyms: ['Lege', 'Klinikk'],
                id: '1810',
                importanceRank: 2,
                verboseModifier: 'allmennmedisin',
                industryCode: '86.211',
            },
            {
                label: 'Spesialistlege.',
                synonyms: ['Lege', 'Klinikk'],
                id: '1820',
                importanceRank: 1000,
                verboseModifier: 'spesialistmedisin',
                industryCode: '86.221',
            },
            {
                label: 'Øyelege.',
                synonyms: ['Klinikk'],
                id: '1822',
                importanceRank: 1000,
                verboseModifier: 'øyemedisin',
                industryCode: '86.221',
            },
            {
                label: 'Gynekolog.',
                synonyms: ['Klinikk'],
                id: '1824',
                importanceRank: 1000,
                verboseModifier: 'gynekologi',
                industryCode: '86.221',
            },
            {
                label: 'Psykolog.',
                synonyms: ['Klinikk'],
                id: '1830',
                importanceRank: 2,
                verboseModifier: 'psykologi',
                industryCode: '86.905',
            },
            {
                label: 'Psykiater.',
                synonyms: ['Klinikk'],
                id: '1840',
                importanceRank: 1000,
                verboseModifier: 'psykiatri',
                industryCode: '86.222',
            },
            {
                label: 'Tannlege.',
                synonyms: ['Klinikk'],
                id: '1850',
                importanceRank: 2,
                verboseModifier: 'tannlegearbeid',
                industryCode: '86.230',
            },
            {
                label: 'Tannpleier.',
                synonyms: ['Klinikk'],
                id: '1860',
                importanceRank: 1000,
                verboseModifier: 'tannpleiearbeid',
                industryCode: '86.909',
            },
            {
                label: 'Jordmor.',
                synonyms: ['Klinikk'],
                id: '1870',
                importanceRank: 1000,
                verboseModifier: 'jordmorarbeid',
                industryCode: '86.909',
            },
            {
                label: 'Kiropraktor.',
                synonyms: ['Klinikk'],
                id: '1880',
                importanceRank: 2,
                verboseModifier: 'kiropraktorarbeid',
                industryCode: '86.909',
            },
            {
                label: 'Audiograf.',
                synonyms: [],
                id: '1882',
                importanceRank: 1000,
                verboseModifier: 'audiografi',
                industryCode: '86.909',
            },
            {
                label: 'Manuellterapeut.',
                synonyms: ['Klinikk'],
                id: '1890',
                importanceRank: 1000,
                verboseModifier: 'manuellterapi',
                industryCode: '86.909',
            },
            {
                label: 'Terapeutisk massasje.',
                synonyms: ['Massasje', 'Klinikk'],
                id: '1900',
                importanceRank: 2,
                verboseModifier: 'terapautisk massasje',
                industryCode: '86.909',
            },
            {
                label: 'Fotterapeut.',
                synonyms: ['Klinikk'],
                id: '1910',
                importanceRank: 2,
                verboseModifier: 'fotterapi',
                industryCode: '86.909',
            },
            {
                label: 'Optiker.',
                synonyms: [],
                id: '1920',
                importanceRank: 1000,
                verboseModifier: 'optikerarbeid',
                industryCode: '86.909',
            },
            {
                label: 'Logoped.',
                synonyms: [],
                id: '1930',
                importanceRank: 1000,
                verboseModifier: 'logopedarbeid',
                industryCode: '86.909',
            },
            {
                label: 'Fysioterapeut.',
                synonyms: ['Klinikk'],
                id: '1940',
                importanceRank: 2,
                verboseModifier: 'fysioterapi',
                industryCode: '86.902',
            },
            {
                label: 'Miljøterapeut.',
                synonyms: [],
                id: '1950',
                importanceRank: 1000,
                verboseModifier: 'miljøterapi',
                industryCode: '86.904',
            },
            {
                label: 'Kostholdsveiledning, ernæringsfysiolog.',
                synonyms: ['Livsstil', 'mat', 'rådgivning'],
                id: '1960',
                importanceRank: 2,
                verboseModifier: 'kostholdsveiledning',
                industryCode: '86.904',
            },
        ],
    },
    {
        label: 'Helse og omsorg',
        id: '224',
        texts: [
            {
                label: 'Støttekontakt for voksne.',
                synonyms: [],
                id: '1970',
                importanceRank: 1000,
                verboseModifier: 'støttekontaktarbeid',
                industryCode: '88.999',
            },
            {
                label: 'Barnevernstjenester.',
                synonyms: [],
                id: '1980',
                importanceRank: 1000,
                verboseModifier: 'barenvern',
                industryCode: '88.991',
            },
            {
                label: 'Fosterhjem.',
                synonyms: [],
                id: '1990',
                importanceRank: 1000,
                verboseModifier: 'fosterhjem',
                industryCode: '88.991',
            },
            {
                label: 'Drift av barnehage.',
                synonyms: [],
                id: '2000',
                importanceRank: 1000,
                verboseModifier: 'barnehagearbeid',
                industryCode: '88.911',
            },
        ],
    },
    {
        label: 'Reparasjoner og vedlikehold',
        id: '230',
        texts: [
            {
                label: 'Reparasjon og vedlikehold av biler.',
                synonyms: ['Bilmekaniker', 'Mekaniker', 'Bilverksted'],
                id: '2020',
                importanceRank: 1,
                verboseModifier: 'reparasjon og vedlikehold av biler',
                industryCode: '45.200',
            },
            {
                label: 'Bilpleie.',
                synonyms: [],
                id: '2021',
                importanceRank: 1,
                verboseModifier: 'bilpleie',
                industryCode: '45.200',
            },
            {
                label: 'Bilvask.',
                synonyms: ['Renhold', 'vask'],
                id: '2022',
                importanceRank: 1,
                verboseModifier: 'bilvask',
                industryCode: '45.200',
            },
            {
                label: 'Reparasjon og vedlikehold av motorsykler.',
                synonyms: ['Mekaniker'],
                id: '2030',
                importanceRank: 1000,
                verboseModifier: 'reparasjon og vedlikehold av motorsykler',
                industryCode: '45.403',
            },
            {
                label: 'Reparasjon av maskiner til landbruk/skogbruk, bygg- og anlegg og industri ellers.',
                synonyms: [],
                id: '2040',
                importanceRank: 1000,
                verboseModifier: 'reparasjon av maskiner',
                industryCode: '33.120',
            },
            {
                label: 'Reparasjon av husholdningsvarer og hageredskaper.',
                synonyms: [],
                id: '2050',
                importanceRank: 1000,
                verboseModifier: 'reparasjon av husholdningsvarer og hageredskaper',
                industryCode: '95.220',
            },
            {
                label: 'Sykkelreparatør.',
                synonyms: ['Sykkelverksted'],
                id: '2060',
                importanceRank: 2,
                verboseModifier: 'sykkelreparasjon',
                industryCode: '95.290',
            },
            {
                label: 'Reparasjon av møbler, omtrekking og restaurering.',
                synonyms: ['Møbeltapetserer'],
                id: '2070',
                importanceRank: 1000,
                verboseModifier: 'reparasjon av møbler og boliginnredning',
                industryCode: '95.240',
            },
            {
                label: 'Reparasjon av datamaskiner.',
                synonyms: [],
                id: '2080',
                importanceRank: 1000,
                verboseModifier: 'reparasjon av datamaskiner',
                industryCode: '95.110',
            },
            {
                label: 'Reparasjon av mobiltelefoner.',
                synonyms: [],
                id: '2090',
                importanceRank: 2,
                verboseModifier: 'reparasjon av mobiltelefoner',
                industryCode: '95.120',
            },
            {
                label: 'Reparasjon og tilpassning av klær.',
                synonyms: ['Skredder'],
                id: '2091',
                importanceRank: 1,
                verboseModifier: 'reparasjon av varer til personlig bruk',
                industryCode: '95.290',
            },
            {
                label: 'Reparasjon og av vedlikehold av skotøy.',
                synonyms: ['Skomaker'],
                id: '2092',
                importanceRank: 1000,
                verboseModifier: 'reparasjon av varer til personlig bruk',
                industryCode: '95.290',
            },
        ],
    },
    {
        label: 'Handel',
        id: '240',
        texts: [
            {
                label: 'Butikkhandel med klær.',
                synonyms: ['Klesbutikk'],
                id: '2100',
                importanceRank: 1,
                verboseModifier: 'kleshandel',
                industryCode: '47.710',
            },
            {
                label: 'Butikkhandel med sko.',
                synonyms: ['skobutikk'],
                id: '2101',
                importanceRank: 1000,
                verboseModifier: 'skotøy',
                industryCode: '47.721',
            },
            {
                label: 'Butikkhandel med sportsutstyr.',
                synonyms: ['sportsbutikk'],
                id: '2102',
                importanceRank: 2,
                verboseModifier: 'sportsutstyr',
                industryCode: '47.641',
            },
            {
                label: 'Butikkhandel med kosmetikk, parfyme og andre produkter til personlig pleie.',
                synonyms: [],
                id: '2103',
                importanceRank: 2,
                verboseModifier: 'kosmetikk og personlig pleie',
                industryCode: '47.750',
            },
            {
                label: 'Butikkhandel med kjøkkeninnredninger og garderobeinnredninger.',
                synonyms: ['kjøkkenbutikk'],
                id: '2105',
                importanceRank: 1000,
                verboseModifier: 'kjøkken- og garderobeinnredninger',
                industryCode: '47.599',
            },
            {
                label: 'Kioskhandel.',
                synonyms: [],
                id: '2106',
                importanceRank: 2,
                verboseModifier: 'kioskhandel',
                industryCode: '47.112',
            },
            {
                label: 'Butikkhandel og netthandel med deler og utstyr til personbiler.',
                synonyms: [],
                id: '2109',
                importanceRank: 1000,
                verboseModifier: 'utstyr til motorvogner',
                industryCode: '45.320',
            },
            {
                label: 'Salg av personbiler, nye og brukte.',
                synonyms: ['Bilbutikk', 'bilforhandler', 'forhandler'],
                id: '2110',
                importanceRank: 1,
                verboseModifier: 'personbiler',
                industryCode: '45.112',
            },
            {
                label: 'Butikkhandel med møbler.',
                synonyms: ['Møbelbutikk'],
                id: '2111',
                importanceRank: 1000,
                verboseModifier: 'møbler',
                industryCode: '47.591',
            },
            {
                label: 'Butikkhandel med interiørartikler.',
                synonyms: ['Interiørbutikk'],
                id: '2112',
                importanceRank: 2,
                verboseModifier: 'interiør',
                industryCode: '47.599',
            },
            {
                label: 'Butikkhandel med kunst.',
                synonyms: ['Kunstgalleri', 'Galleri'],
                id: '2113',
                importanceRank: 1000,
                verboseModifier: 'kunst',
                industryCode: '47.789',
            },
            {
                label: 'Butikkhandel med garn og tilbehør.',
                synonyms: [
                    'Strikkebutikk',
                    'strikking',
                    'strikketøy',
                    'håndarbeid',
                    'possement',
                ],
                id: '2114',
                importanceRank: 2,
                verboseModifier: 'utstyr til håndarbeid',
                industryCode: '47.510',
            },
            {
                label: 'Agenturhandel med klær.',
                synonyms: ['klesagentur'],
                id: '2115',
                importanceRank: 2,
                verboseModifier: 'tekstiler og lærvarer',
                industryCode: '46.160',
            },
            {
                label: 'Agenturhandel med interiørartikler.',
                synonyms: ['møbelagentur'],
                id: '2116',
                importanceRank: 2,
                verboseModifier: 'interiør',
                industryCode: '46.150',
            },
            {
                label: 'Agenturhandel med biler.',
                synonyms: ['bilagent', 'bilagentur'],
                id: '2117',
                importanceRank: 2,
                verboseModifier: 'kjøretøy',
                industryCode: '45.111',
            },
            {
                label: 'Dagligvarebutikk.',
                synonyms: ['Matbutikk'],
                id: '2120',
                importanceRank: 1,
                verboseModifier: 'dagligvarhandel',
                industryCode: '47.111',
            },
        ],
    },
    {
        label: 'Bensin- og ladestasjon',
        id: '245',
        texts: [
            {
                label: 'Ladestasjon for tyngre kjøretøy.',
                synonyms: [],
                id: '2121',
                importanceRank: 1000,
                verboseModifier: 'lading av tyngre kjøretøy',
                industryCode: '47.300',
            },
            {
                label: 'Bensinstasjon, betjent.',
                synonyms: [],
                id: '2122',
                importanceRank: 1000,
                verboseModifier: 'drivstoff',
                industryCode: '47.300',
            },
            {
                label: 'Bensinstasjon, ubetjent.',
                synonyms: [],
                id: '2123',
                importanceRank: 1000,
                verboseModifier: 'drivstoff',
                industryCode: '47.300',
            },
            {
                label: 'Ladestasjon for elbiler.',
                synonyms: [],
                id: '2124',
                importanceRank: 1000,
                verboseModifier: 'lading av elbiler',
                industryCode: '47.300',
            },
        ],
    },
    {
        label: 'Transport og budtjenester',
        id: '250',
        texts: [
            {
                label: 'Drosjekjøring.',
                synonyms: ['Taxi'],
                id: '2130',
                importanceRank: 2,
                verboseModifier: 'drosjekjøring',
                industryCode: '49.320',
            },
            {
                label: 'Flyttetransport.',
                synonyms: ['Flyttehjelp', 'flyttebyrå', 'flyttebil'],
                id: '2131',
                importanceRank: 1000,
                verboseModifier: 'flytting',
                industryCode: '49.420',
            },
            {
                label: 'Lastebiltransport.',
                synonyms: [],
                id: '2140',
                importanceRank: 1,
                verboseModifier: 'lastebiltransport',
                industryCode: '49.410',
            },
            {
                label: 'Transport av gods på vei.',
                synonyms: [],
                id: '2142',
                importanceRank: 1,
                verboseModifier: 'godstransport på vei',
                industryCode: '49.410',
            },
            {
                label: 'Utenriks sjøfart med gods.',
                synonyms: [],
                id: '2145',
                importanceRank: 1000,
                verboseModifier: 'utenriks sjøfart',
                industryCode: '50.201',
            },
        ],
    },
    {
        label: 'Mat',
        id: '260',
        texts: [
            {
                label: 'Drift av restaurant/kafe.',
                synonyms: ['Restaurant', 'Café'],
                id: '2180',
                importanceRank: 1,
                verboseModifier: 'restaurantdrift',
                industryCode: '56.101',
            },
            {
                label: 'Drift av pub.',
                synonyms: ['bar'],
                id: '2181',
                importanceRank: 1,
                verboseModifier: 'pubdrift',
                industryCode: '56.301',
            },
            {
                label: 'Drift av gatekjøkken.',
                synonyms: [
                    'Gatekjøkken',
                    'Food truck',
                    'Matbod',
                    'Take away',
                    'Pølsebu',
                ],
                id: '2190',
                importanceRank: 1,
                verboseModifier: 'gatekjøkkendrift',
                industryCode: '56.102',
            },
            {
                label: 'Catering.',
                synonyms: [],
                id: '2200',
                importanceRank: 2,
                verboseModifier: 'catering',
                industryCode: '56.210',
            },
            {
                label: 'Konditori.',
                synonyms: ['Kaker'],
                id: '2210',
                importanceRank: 1000,
                verboseModifier: 'konditori',
                industryCode: '56.101',
            },
            {
                label: 'Drift av kantine.',
                synonyms: ['Kjøkken'],
                id: '2220',
                importanceRank: 1000,
                verboseModifier: 'kantinedrift',
                industryCode: '56.290',
            },
            {
                label: 'Produksjon og salg av bakevarer.',
                synonyms: ['Bakeri'],
                id: '2230',
                importanceRank: 1000,
                verboseModifier: 'produksjon av bakevarer',
                industryCode: '10.710',
            },
        ],
    },
    {
        label: 'Reiseliv og overnatting',
        id: '270',
        texts: [
            {
                label: 'Utleie av feriehus.',
                synonyms: [],
                id: '2240',
                importanceRank: 1000,
                verboseModifier: 'utleie av feriehus',
                industryCode: '55.202',
            },
            {
                label: 'Drift av campingplass.',
                synonyms: ['Camping'],
                id: '2250',
                importanceRank: 2,
                verboseModifier: 'drift av campingplass',
                industryCode: '55.300',
            },
            {
                label: 'Hotell, pensjonat, motell (med restaurant).',
                synonyms: [],
                id: '2260',
                importanceRank: 1000,
                verboseModifier: 'overnatting og matservering',
                industryCode: '55.101',
            },
            {
                label: 'Hotell, pensjonat, motell (uten restaurant).',
                synonyms: [],
                id: '2270',
                importanceRank: 1000,
                verboseModifier: 'overnatting uten matservering',
                industryCode: '55.102',
            },
            {
                label: 'Guide og reiseleder.',
                synonyms: ['Turisme', 'Opplevelser'],
                id: '2280',
                importanceRank: 1,
                verboseModifier: 'guiding og reiseleding',
                industryCode: '79.902',
            },
        ],
    },
    {
        label: 'Utleie',
        id: '280',
        texts: [
            {
                label: 'Utleie av fast eiendom.',
                synonyms: [],
                id: '2290',
                importanceRank: 1,
                verboseModifier: 'utleie av eiendom',
                industryCode: '68.209',
            },
            {
                label: 'Utleie av båt (uten fører).',
                synonyms: ['båtutleie'],
                id: '2291',
                importanceRank: 1000,
                verboseModifier: 'båtutleie',
                industryCode: '77.210',
            },
            {
                label: 'Utleie av snøskuter.',
                synonyms: ['scooter', 'snøscooter'],
                id: '2292',
                importanceRank: 1000,
                verboseModifier: 'utleie av snøskuter',
                industryCode: '77.110',
            },
            {
                label: 'Utleie av sykler.',
                synonyms: ['sykkelutleie', 'sykkel'],
                id: '2293',
                importanceRank: 1000,
                verboseModifier: 'sykkelutleie',
                industryCode: '77.210',
            },
            {
                label: 'Utleie av EL-sparkesykler.',
                synonyms: [],
                id: '2294',
                importanceRank: 1000,
                verboseModifier: 'utleie av el-sparkesykler',
                industryCode: '77.210',
            },
            {
                label: 'Utleie av personbiler (uten fører).',
                synonyms: ['Leiebil'],
                id: '2300',
                importanceRank: 2,
                verboseModifier: 'utleie av personbiler',
                industryCode: '77.110',
            },
            {
                label: 'Utleie av lastebiler (uten fører).',
                synonyms: ['Leiebil'],
                id: '2310',
                importanceRank: 1000,
                verboseModifier: 'utleie av lastebiler',
                industryCode: '77.120',
            },
            {
                label: 'Utleie og leasing av landbruksmaskiner og -utstyr uten fører.',
                synonyms: [],
                id: '2311',
                importanceRank: 1000,
                verboseModifier: 'utleie av landbruksmaskiner',
                industryCode: '77.310',
            },
            {
                label: 'Utleie av bygg- og anleggsmaskiner (uten personell).',
                synonyms: ['Maskinutleie'],
                id: '2320',
                importanceRank: 2,
                verboseModifier: 'utleie av bygg og anleggsmaskiner',
                industryCode: '77.320',
            },
            {
                label: 'Korttidsutleie av hus, hytte, leilighet eller rom.',
                synonyms: [],
                id: '2331',
                importanceRank: 2,
                verboseModifier: 'korttidsutleie av eiendom',
                industryCode: '55.202',
            },
        ],
    },
    {
        label: 'Eiendom',
        id: '290',
        texts: [
            {
                label: 'Vaktmestertjenester.',
                synonyms: ['Vaktmester'],
                id: '2340',
                importanceRank: 1,
                verboseModifier: 'vaktmesterarbeid',
                industryCode: '81.101',
            },
            {
                label: 'Boligstyling.',
                synonyms: ['Interiør', 'boligstyling'],
                id: '2341',
                importanceRank: 1,
                verboseModifier: 'boligstyling',
                industryCode: '74.103',
            },
            {
                label: 'Rydding og organisering av private hjem og virksomheter.',
                synonyms: ['Rengjøring', 'vaskedame', 'vaskehjelp', 'renhold'],
                id: '2342',
                importanceRank: 1,
                verboseModifier: 'rydding og rengjøring',
                industryCode: '81.210',
            },
            {
                label: 'Gartnertjenester.',
                synonyms: ['Gartner', 'hage'],
                id: '2350',
                importanceRank: 1000,
                verboseModifier: 'gartnerarbeid',
                industryCode: '81.300',
            },
            {
                label: 'Arkitekttjenester, bygg.',
                synonyms: ['Arkitekt'],
                id: '2360',
                importanceRank: 1,
                verboseModifier: 'arkitektur',
                industryCode: '71.112',
            },
            {
                label: 'Interiørarkitekt, interiørdesign og interiørkonsulenttjenester.',
                synonyms: ['Interiør', 'bolig'],
                id: '2370',
                importanceRank: 1,
                verboseModifier: 'interiør',
                industryCode: '74.103',
            },
            {
                label: 'Kjøp og salg av egen fast eiendom.',
                synonyms: [],
                id: '2391',
                importanceRank: 1,
                verboseModifier: 'eiendomssalg',
                industryCode: '68.100',
            },
            {
                label: 'Eiendomsforvaltning på vegne av andre.',
                synonyms: ['Utleiemegler', 'drift', 'vedlikehold'],
                id: '2392',
                importanceRank: 2,
                verboseModifier: 'eiendomsforvaltning',
                industryCode: '68.320',
            },
            {
                label: 'Eiendomsmegler.',
                synonyms: [],
                id: '2395',
                importanceRank: 1000,
                verboseModifier: 'eiendomsmegling',
                industryCode: '68.310',
            },
        ],
    },
    {
        label: 'Renhold',
        id: '300',
        texts: [
            {
                label: 'Rengjøring av bygninger, bolighus, kontorer og lignende.',
                synonyms: ['Renhold inne', 'Vask inne'],
                id: '2400',
                importanceRank: 1,
                verboseModifier: 'innvendig rengjøring',
                industryCode: '81.210',
            },
            {
                label: 'Rengjøring av bygninger utvendig, vinduer og lignende.',
                synonyms: ['Renhold utvendig', 'Vask ute'],
                id: '2420',
                importanceRank: 2,
                verboseModifier: 'utvendig rengjøring',
                industryCode: '81.220',
            },
            {
                label: 'Fasadevask.',
                synonyms: ['Rengjøring'],
                id: '2421',
                importanceRank: 1000,
                verboseModifier: 'fasadevask',
                industryCode: '81.220',
            },
        ],
    },
    {
        label: 'Trening',
        id: '310',
        texts: [
            {
                label: 'Treningssenter.',
                synonyms: ['gym'],
                id: '2435',
                importanceRank: 2,
                verboseModifier: 'drift av treningssenter',
                industryCode: '93.130',
            },
        ],
    },
    {
        label: 'Opplevelsesaktiviteter',
        id: '311',
        texts: [
            {
                label: 'Organisering og utleie av utstyr til rafting.',
                synonyms: [],
                id: '3000',
                importanceRank: 1000,
                verboseModifier: 'rafting',
                industryCode: '93.291',
            },
            {
                label: 'Organisering og utleie av utstyr til fjellklatring.',
                synonyms: [],
                id: '3001',
                importanceRank: 1000,
                verboseModifier: 'fjellklatring',
                industryCode: '93.291',
            },
            {
                label: 'Organisering og utleie av utstyr til hundesledeturer.',
                synonyms: [],
                id: '3002',
                importanceRank: 1000,
                verboseModifier: 'hundesledeturer',
                industryCode: '93.291',
            },
        ],
    },
    {
        label: 'Regnskap og revisjon',
        id: '320',
        texts: [
            {
                label: 'Regnskapsføring.',
                synonyms: ['Regnskapsfører'],
                id: '2480',
                importanceRank: 1,
                verboseModifier: 'regnskapsføring',
                industryCode: '69.201',
            },
            {
                label: 'Revisjon.',
                synonyms: ['Revisor'],
                id: '2490',
                importanceRank: 1000,
                verboseModifier: 'revisjon',
                industryCode: '69.202',
            },
        ],
    },
    {
        label: 'Juridisk tjeneste',
        id: '330',
        texts: [
            {
                label: 'Advokat.',
                synonyms: [],
                id: '2500',
                importanceRank: 2,
                verboseModifier: 'advokatarbeid',
                industryCode: '69.100',
            },
            {
                label: 'Juridisk rådgivning.',
                synonyms: [],
                id: '2510',
                importanceRank: 2,
                verboseModifier: 'juridisk rådgivning',
                industryCode: '69.100',
            },
        ],
    },
    {
        label: 'Konsulent',
        id: '340',
        texts: [
            {
                label: 'Ingeniørtjenester.',
                synonyms: ['Ingeniør'],
                id: '2520',
                importanceRank: 1,
                verboseModifier: 'ingeniørarbeid',
                industryCode: '71.129',
            },
            {
                label: 'Rådgivning innen industri.',
                synonyms: [],
                id: '2530',
                importanceRank: 1,
                verboseModifier: 'industrirådgivning',
                industryCode: '71.129',
            },
            {
                label: 'Industridesign, produktdesign og annen teknisk design.',
                synonyms: [],
                id: '2550',
                importanceRank: 1,
                verboseModifier: 'industridesign',
                industryCode: '74.101',
            },
            {
                label: 'Rådgivning innen olje og gassutvinning.',
                synonyms: [],
                id: '2560',
                importanceRank: 2,
                verboseModifier: 'olje- og gassutvinningsrådgivning',
                industryCode: '71.129',
            },
        ],
    },
    {
        label: 'Media og kommunikasjon',
        id: '350',
        texts: [
            {
                label: 'Fotograf.',
                synonyms: ['foto'],
                id: '2590',
                importanceRank: 1,
                verboseModifier: 'fotografi',
                industryCode: '74.200',
            },
            {
                label: 'Forlagsvirksomhet, utgivelse av bøker.',
                synonyms: ['Forlag', 'Trykk', 'Publisering'],
                id: '2595',
                importanceRank: 2,
                verboseModifier: 'utgivelse av bøker',
                industryCode: '58.110',
            },
            {
                label: 'Markedsføring og reklame.',
                synonyms: [],
                id: '2600',
                importanceRank: 1,
                verboseModifier: 'markedsføring',
                industryCode: '73.110',
            },
            {
                label: 'Filmproduksjon.',
                synonyms: ['Film'],
                id: '2610',
                importanceRank: 2,
                verboseModifier: 'filmproduksjon',
                industryCode: '59.110',
            },
            {
                label: 'Etterarbeid knyttet til prod. av film, video og fjernsynsprogrammer.',
                synonyms: ['Filmproduksjon', 'TV', 'Post-prod', 'Post-produksjon'],
                id: '2620',
                importanceRank: 1000,
                verboseModifier: 'etterarbeid av video',
                industryCode: '59.120',
            },
            {
                label: 'PR og kommunikasjonstjenester.',
                synonyms: [],
                id: '2630',
                importanceRank: 2,
                verboseModifier: 'PR og kommunikasjonsarbeid',
                industryCode: '70.210',
            },
        ],
    },
    {
        label: 'Kraftproduksjon',
        id: '352',
        texts: [
            {
                label: 'Produksjon av elektrisitet fra vannkraft.',
                synonyms: [],
                id: '2900',
                importanceRank: 1000,
                verboseModifier: 'produksjon av elektrisitet fra vannkraft',
                industryCode: '35.111',
            },
            {
                label: 'Produksjon av elektrisitet fra vindkraft.',
                synonyms: [],
                id: '2901',
                importanceRank: 1000,
                verboseModifier: 'produksjon av elektrisitet fra vindkraft',
                industryCode: '35.112',
            },
            {
                label: 'Produksjon av elektrisitet fra biobrensel, avfall eller deponigass.',
                synonyms: [],
                id: '2902',
                importanceRank: 1000,
                verboseModifier: 'produksjon av elektrisitet fra biobrensel, avfall eller deponigass',
                industryCode: '35.113',
            },
        ],
    },
    {
        label: 'Investering og holding',
        id: '355',
        texts: [
            {
                label: 'Investering i aksjer og verdipapirer.',
                synonyms: ['Investeringsselskap'],
                id: '2830',
                importanceRank: 1,
                verboseModifier: 'Investere i selskaper og eiendom og alt annet som naturlig faller sammen med dette, herunder å delta i andre selskaper med lignende virksomhet, kjøp og salg av aksjer, eller på annen måte gjøre seg interessert i andre foretagende.',
                industryCode: '00.000',
            },
            {
                label: 'Hylleselskap, opprettet for videresalg.',
                synonyms: [],
                id: '2832',
                importanceRank: 1000,
                verboseModifier: 'Selges videre som et ferdigregistrert AS, uten tidligere drift.',
                industryCode: '00.000',
            },
            {
                label: 'Holdingselskap.',
                synonyms: [],
                id: '2835',
                importanceRank: 1,
                verboseModifier: 'Investere i selskaper og eiendom og alt annet som naturlig faller sammen med dette, herunder å delta i andre selskaper med lignende virksomhet, kjøp og salg av aksjer, eller på annen måte gjøre seg interessert i andre foretagende.',
                industryCode: '00.000',
            },
        ],
    },
    {
        label: 'Annet',
        id: '370',
        texts: [
            {
                label: 'Bedriftsrådgivning, administrativt.',
                synonyms: [],
                id: '2650',
                importanceRank: 1,
                verboseModifier: 'bedriftsrådgivning',
                industryCode: '70.220',
            },
            {
                label: 'Telefonsalg på vegne av andre.',
                synonyms: ['Selger'],
                id: '2651',
                importanceRank: 1000,
                verboseModifier: 'telefonsalg',
                industryCode: '82.202',
            },
            {
                label: 'Begravelsesbyrå.',
                synonyms: ['begravelsesagent', 'begravelse', 'gravferd'],
                id: '2652',
                importanceRank: 1000,
                verboseModifier: 'begravelse',
                industryCode: '96.030',
            },
            {
                label: 'Oversettelse- og tolketjenester.',
                synonyms: [],
                id: '2720',
                importanceRank: 1000,
                verboseModifier: 'oversettelse og tolkning',
                industryCode: '74.300',
            },
            {
                label: 'Søm av bunad.',
                synonyms: [],
                id: '2780',
                importanceRank: 1000,
                verboseModifier: 'søm av bunad',
                industryCode: '14.130',
            },
        ],
    },
    {
        label: 'Nettbutikk',
        id: '390',
        texts: [
            {
                label: 'Netthandel med kosmetikk, parfyme og andre produkter til personlig pleie.',
                synonyms: ['Nettbutikk', 'skjønnhet', 'velvære'],
                id: '2107',
                importanceRank: 1,
                verboseModifier: 'kosmetikk og personlig pleie',
                industryCode: '47.919',
            },
            {
                label: 'Netthandel med sportsutstyr.',
                synonyms: ['sportsbutikk'],
                id: '3060',
                importanceRank: 1,
                verboseModifier: 'sportsutstyr',
                industryCode: '47.912',
            },
            {
                label: 'Netthandel med kjøkkeninnredninger og garderobeinnredninger.',
                synonyms: ['kjøkkenbutikk'],
                id: '3061',
                importanceRank: 2,
                verboseModifier: 'kjøkken- og gardrobeinnredning',
                industryCode: '47.919',
            },
            {
                label: 'Netthandel med møbler og interiørartikler.',
                synonyms: ['møbelbutikk', 'interiørbutikk'],
                id: '3062',
                importanceRank: 1,
                verboseModifier: 'møbler og interiør',
                industryCode: '47.913',
            },
            {
                label: 'Netthandel med kunst.',
                synonyms: ['kunstgalleri', 'galleri'],
                id: '3063',
                importanceRank: 2,
                verboseModifier: 'kunst',
                industryCode: '47.919',
            },
            {
                label: 'Netthandel med garn og tilbehør.',
                synonyms: ['strikkebutikk', 'strikketøy', 'håndarbeid'],
                id: '3064',
                importanceRank: 1,
                verboseModifier: 'utstyr til håndarbeid',
                industryCode: '47.919',
            },
            {
                label: 'Netthandel med klær.',
                synonyms: ['Nettbutikk'],
                id: '3065',
                importanceRank: 1,
                verboseModifier: 'klær via netthandel',
                industryCode: '47.912',
            },
            {
                label: 'Netthandel med sko.',
                synonyms: ['Nettbutikk'],
                id: '3066',
                importanceRank: 1,
                verboseModifier: 'sko via netthandel',
                industryCode: '47.912',
            },
            {
                label: 'Netthandel med tekstiler og utstyrsvarer.',
                synonyms: ['Nettbutikk'],
                id: '3067',
                importanceRank: 1000,
                verboseModifier: 'tekstiler og utstyr via netthandel',
                industryCode: '47.912',
            },
        ],
    },
    {
        label: 'Brukthandel',
        id: '392',
        texts: [
            {
                label: 'Netthandel med antikviteter.',
                synonyms: ['antikvitetsbutikk', 'bruktbutikk', 'Nettbutikk'],
                id: '3090',
                importanceRank: 2,
                verboseModifier: 'antikviteter',
                industryCode: '47.919',
            },
            {
                label: 'Netthandel med brukte møbler og annet innbo.',
                synonyms: ['bruktbutikk', 'nettbutikk'],
                id: '3092',
                importanceRank: 2,
                verboseModifier: 'brukte møbler og interiør',
                industryCode: '47.912',
            },
            {
                label: 'Butikkhandel med antikviteter.',
                synonyms: ['antikvitetsbutikk', 'bruktbutikk'],
                id: '3093',
                importanceRank: 1000,
                verboseModifier: 'antikviteter',
                industryCode: '47.791',
            },
            {
                label: 'Butikkhandel med brukte klær og sko.',
                synonyms: ['bruktbutikk', 'secondhand', 'vintage', 'redesign', 'brukt'],
                id: '3094',
                importanceRank: 2,
                verboseModifier: 'brukte klær og sko',
                industryCode: '47.792',
            },
            {
                label: 'Butikkhandel med brukte møbler og annet innbo.',
                synonyms: ['antikvitetsbutikk', 'møbelbutikk', 'bruktbutikk'],
                id: '3095',
                importanceRank: 2,
                verboseModifier: 'brukte møbler og interiør',
                industryCode: '47.799',
            },
            {
                label: 'Netthandel med brukte klær.',
                synonyms: [
                    'bruktbutikk',
                    'secondhand',
                    'vintage',
                    'redesign',
                    'brukt',
                    'Nettbutikk',
                ],
                id: '3096',
                importanceRank: 2,
                verboseModifier: 'brukte klær',
                industryCode: '47.912',
            },
            {
                label: 'Netthandel med brukte sko.',
                synonyms: [
                    'bruktbutikk',
                    'secondhand',
                    'vintage',
                    'redesign',
                    'brukt',
                    'Nettbutikk',
                ],
                id: '3097',
                importanceRank: 2,
                verboseModifier: 'brukte sko',
                industryCode: '47.912',
            },
        ],
    },
];
//# sourceMappingURL=index.js.map